<template>

  <div :class="className" :style="info.css" @click.prevent="click" v-if="image">
    <img :src="image" class="img" @load="onLoad"/>
    <div v-if="loading" class="loading">
      <div class="fall"></div>
      <van-loading type="spinner" color="white"/>
    </div>
  </div>
  <div class="actImgHolder" :style="info.css" v-else-if="!image && edit">

  </div>
</template>


<script>
  /**
   * 如果没有default 并且没有指定的platform ,就不显示图片
   */
  import click_handler from '../../tools/mgtv/click'
  import handler_action from '../../tools/mgtv/action'
  import Vue from 'vue';

  export default {
    name: 'ActImg',
    props: ['info'],
    components: {},
    data() {
      return {
        loading: false
      }
    },
    methods: {
      click() {
        if (!this.image) {
          return;
        }
        if (!this.info.action_type || this.info.action_type === 'none') {
          return;
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        setTimeout(() => {
          this.loading = false
        }, 333);

        click_handler(this.info.name, () => {
          handler_action(this.info)
        }, {
          need_login: this.info.action_info.need_login,
          need_act: this.info.action_info.need_act,
          need_new_user:this.info.action_info.need_new_user,
          need_vip_level: this.info.action_info.need_vip_level,
        })
      },
      onLoad() {

      }
    },
    computed: {
      image() {
        if (this.info.act_img_src === 'null') {
          return null;
        }
        return this.info.act_img_src;
      },
      edit() {
        return window.gact.edit
      },
      className() {
        try {
          const name = this.info['animate_name'];
          const times = this.info['animate_times'];
          const delay = this.info['animate_delay'];
          const speed = this.info['animate_speed'];
          const animateClass = `animated ${name} ${times} ${delay} ${speed}`;
          return `actImg ${animateClass}`
        } catch (e) {
          return 'actImg';
        }
      }
    },
    mounted() {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">
  .actImg
    overflow hidden
    .img
      display block
      width 100%
      height 100%

  .actImgHolder
    border 1px dashed red
    color red
    display flex
    justify-content center
    align-items center

  .loading
    position absolute
    width 100%
    height 100%
    top 0
    left 0
    display flex
    justify-content center
    align-items center

  .fall
    position absolute
    width 100%
    height 100%
    top 0
    left 0
    background-color: rgba(0, 0, 0, .3);

</style>



// WEBPACK FOOTER //
// src/components/ConfigUI/ActImg.vue